import React from 'react';
import { bool, func, shape } from 'prop-types';
import { faShare, faUsers } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'antd';
import { Share } from 'arcl';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import './style.scss';

function DetailBar({ programDetails, handleJoinMentorshipClick, loading }) {
  return (
    <div className="mentorship-details-wrapper">
      <Row type="flex" justify="space-between">
        <Col xs={24} sm={24} md={14} lg={14} xl={14}>
          <Row>
            <h2 className="arc-H500 arc-color-gray-9 program-title">{programDetails.name}</h2>
          </Row>
          <Row align="middle" className="mb12">
            <If condition={window?.totalMembers}>
              <FontAwesomeIcon icon={faUsers} className="mr8 detail-bar-icon" size="sm" />
              <p className="arc-color-gray-7">
                <I18nCustomFormatter id="people-attending-label" values={{ count: window?.totalMembers }} />
              </p>
            </If>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Row>
            <Choose>
              <When condition={programDetails?.accept_registrations}>
                <Button type="primary" size="large" block onClick={handleJoinMentorshipClick} loading={loading} className='arc-focus-outline'>
                  <I18nCustomFormatter id="join-mentorship-cta" />
                </Button>
              </When>
              <Otherwise>
                <Button type="primary" size="large" block disabled>
                  <I18nCustomFormatter id="registration-closed-label" />
                </Button>
              </Otherwise>
            </Choose>
          </Row>
          <Row justify="center">
            <div className="share-card-actions mt16">
              <Share title="Share" url={`${window.location.origin}${window.location.pathname}`} disableNativeShare>
                <div className="share-card-icon-text">
                  <span id="share-trigger" className="arc-anchor">
                    <I18nCustomFormatter id="share-button" />
                  </span>
                  <FontAwesomeIcon icon={faShare} className="ml12" />
                </div>
              </Share>
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

DetailBar.propTypes = {
  handleJoinMentorshipClick: func.isRequired,
  loading: bool.isRequired,
  programDetails: shape().isRequired,
};

export default DetailBar;
